import { useContext } from "react";
import { IntegratorAuthContext } from "../contexts/IntegratorAuthContext";

export default function useIntegratorAuth() {
  return useContext(IntegratorAuthContext);
}